import React, { useEffect, useState } from 'react';
import { BlockPreviewComponent } from '../../lib/declarations/EditorComponentTypes';
import { useCurrentBlock } from '../CurrentBlockProvider';
import { AudioBlock } from '../../../declarations/models/blocks/AudioBlock';
import { DMArtifact } from '../../../declarations/models/DMMediaModel';
import { Api } from '../../../services/Api';
import { calculateObjectPosition } from '../../../components/Image';

export const AudioBlockPreview: BlockPreviewComponent = () => {
  const { block } = useCurrentBlock();
  const currentBlock = block as AudioBlock;
  const [dmArtifact, setDMArtifact] = useState<DMArtifact>();
  const [audioFile, setAudioFile] = useState<any>(undefined);

  const media = currentBlock?.mediaobject;

  const getBodyOrDescription = (text: string, layout: string) => {
    return text;
  };

  useEffect(() => {
    if (currentBlock.dmItem) {
      if (currentBlock.dmItem.uniqueId) {
        const ctx = Api.getDMArtifact(currentBlock.dmItem.uniqueId);

        ctx
          .fetchDirect(null)
          .then((res) => !!res && setDMArtifact(res))
          .finally(ctx.abort);
      }
    } else setDMArtifact(undefined);
  }, [currentBlock.dmItem, currentBlock.dmItem?.uniqueId]);

  useEffect(() => {
    if (dmArtifact && dmArtifact.files) {
      const foundAudioFile = dmArtifact.files.find((file) => file.fileType === 'Audio' || file.fileType === 'audio');
      setAudioFile(foundAudioFile);
    } else {
      setAudioFile(undefined);
    }
  }, [dmArtifact]);

  return (
    <div className='article__grid' data-layout={currentBlock?.layout || 'normal'}>
      <div className='article__bodytext'>
        {currentBlock?.visibletitle && <h2>{currentBlock?.title}</h2>}
        <p>{currentBlock?.body}</p>
      </div>
      {currentBlock.source !== 'external' && (
        <>
          <div className={`module module--audio layout--${currentBlock?.layout || 'normal'} `}>
            <div className={`module__grid skin-audio ${currentBlock?.skin || 'skin'}`}>
              {currentBlock?.audio?.content?.poster && (
                <div className='module__media'>
                  <img
                    alt=''
                    style={{
                      objectPosition: calculateObjectPosition(
                        currentBlock?.audio.local?.x,
                        currentBlock?.audio.local?.y,
                      ),
                    }}
                    src={`${currentBlock.audio?.content?.poster?.url || ''}`}
                  />
                </div>
              )}
              {dmArtifact?.images && dmArtifact.images.length > 0 && (
                <div className='module__media'>
                  <img alt='' src={`https://ems.dimu.org/image/${dmArtifact.images[0].mediaId || ''}`} />
                </div>
              )}

              <div className='module__content'>
                <div className='module__head'>
                  <h2>
                    {currentBlock?.dmItem?.local?.title ||
                      dmArtifact?.title ||
                      currentBlock?.audio?.local?.title ||
                      currentBlock?.audio?.title ||
                      currentBlock?.audio?.filename ||
                      ''}
                  </h2>
                </div>
                <div className='module__body'>
                  {/* eslint-disable-next-line react/no-danger */}
                  <p
                    className='modulebodytext'
                    dangerouslySetInnerHTML={{
                      __html: getBodyOrDescription(
                        currentBlock.dmItem?.local?.caption ||
                          dmArtifact?.description ||
                          currentBlock?.audio?.local?.caption ||
                          currentBlock?.audio?.content?.caption ||
                          '',
                        currentBlock?.layout || 'normal',
                      ),
                    }}
                  />

                  {currentBlock?.audio?.id && (
                    /* eslint-disable-next-line jsx-a11y/media-has-caption */
                    <audio controls>
                      <source src={currentBlock?.audio?.play_urls?.mp3} type='audio/mp3' />
                    </audio>
                  )}
                  {dmArtifact?.files && dmArtifact.files.length > 0 && audioFile && (
                    /* eslint-disable-next-line jsx-a11y/media-has-caption */
                    <audio controls>
                      <source
                        src={`https://ems.dimu.org/multimedia/${audioFile?.mediaId}.mp3?mmid=${audioFile?.mediaId}`}
                        type='audio/mp3'
                      />
                    </audio>
                  )}
                </div>
                <div className='module__foot'>
                  {currentBlock?.audio && !currentBlock?.audio?.local?.disableCredits && (
                    <div className='audio__credits'>
                      {currentBlock?.audio?.content?.credits && (
                        <span className='media__credit  caption--credit'>
                          {currentBlock?.audio?.content?.credits &&
                            currentBlock?.audio?.content?.credits?.length > 0 &&
                            currentBlock?.audio?.content?.credits?.map(
                              (credit) =>
                                credit?.name && (
                                  <span className={credit?.type} key={credit?.name}>
                                    {credit?.name} &nbsp;
                                  </span>
                                ),
                            )}
                        </span>
                      )}
                    </div>
                  )}
                  {currentBlock?.dmItem && <div className='audio__credits'>DM-link + Eier</div>}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {currentBlock.source === 'external' && (
        <div className='article__bodytext'>
          <p className=' preview__blockmessage info' style={{ marginTop: '2em', marginBottom: '2em' }}>
            LYD: Eksternt innhold fra <strong>{currentBlock?.provider || '----'}</strong> vises kun i sluttportal.
          </p>
        </div>
      )}
    </div>
  );
};

export default AudioBlockPreview;
